import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6382280c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-assistant-statistics" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "launch-notice" }, "功能上线时间：2026-10-13", -1))
const _hoisted_3 = { class: "overview" }
const _hoisted_4 = { class: "summary-grid" }
const _hoisted_5 = { class: "summary-card visits-card" }
const _hoisted_6 = { class: "metric-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "页面访问次数", -1))
const _hoisted_8 = { class: "metric-value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客户分析、用户画像、聊天辅助", -1))
const _hoisted_11 = { class: "summary-card calls-card" }
const _hoisted_12 = { class: "metric-icon" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "接口调用次数", -1))
const _hoisted_14 = { class: "metric-value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "话术生成、话术优化、匹配八大服务", -1))
const _hoisted_17 = { class: "summary-card users-card" }
const _hoisted_18 = { class: "metric-icon" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "使用人数", -1))
const _hoisted_20 = { class: "metric-value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "按查询时间范围内的用户去重统计", -1))
const _hoisted_23 = { class: "summary-card messages-card" }
const _hoisted_24 = { class: "metric-icon" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "metric-label" }, "消息发送次数", -1))
const _hoisted_26 = { class: "metric-value" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次", -1))
const _hoisted_28 = { class: "detail-grid" }
const _hoisted_29 = { class: "detail-card" }
const _hoisted_30 = { class: "detail-heading" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "页面访问明细"),
  /*#__PURE__*/_createElementVNode("p", null, "各功能页面访问次数及占比")
], -1))
const _hoisted_32 = {
  key: 0,
  class: "total-badge"
}
const _hoisted_33 = { class: "table-state" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " { errorMessage ? '统计数据加载失败' : '正在加载统计数据…' } ", -1))
const _hoisted_35 = { class: "table-count" }
const _hoisted_36 = { class: "share-cell" }
const _hoisted_37 = { class: "detail-card calls-detail" }
const _hoisted_38 = { class: "detail-heading" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "接口调用明细"),
  /*#__PURE__*/_createElementVNode("p", null, "各功能接口调用次数及占比")
], -1))
const _hoisted_40 = {
  key: 0,
  class: "total-badge"
}
const _hoisted_41 = { class: "table-state" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " { errorMessage ? '统计数据加载失败' : '正在加载统计数据…' } ", -1))
const _hoisted_43 = { class: "table-count" }
const _hoisted_44 = { class: "share-cell" }
const _hoisted_45 = { class: "detail-card message-detail" }
const _hoisted_46 = { class: "detail-heading" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "员工消息发送统计"),
  /*#__PURE__*/_createElementVNode("p", null, "仅展示统计范围内有发送记录的员工")
], -1))
const _hoisted_48 = {
  key: 0,
  class: "total-badge"
}
const _hoisted_49 = { class: "table-state" }
const _hoisted_50 = { class: "table-count" }

import { computed, onBeforeUnmount, ref } from 'vue'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import {
  Connection,
  DataAnalysis,
  User,
  ChatDotRound
} from '@element-plus/icons-vue'
import {
  fetchAiAssistantOverview,
  fetchEmployeeMessageCounts
} from './ai-assistant-statistics.service'
import type {
  AiAssistantOverview,
  EmployeeMessageCount
} from './ai-assistant-statistics.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'AiAssistantStatistics',
  setup(__props) {

const defaultDateRange = (): [string, string] => [
  dayjs().startOf('month').format('YYYY-MM-DD'),
  dayjs().format('YYYY-MM-DD')
]
const dateRange = ref<[string, string]>(defaultDateRange())
const overview = ref<AiAssistantOverview | null>(null)
const loading = ref(false)
const errorMessage = ref('')
const messageRows = ref<EmployeeMessageCount[] | null>(null)
const messageLoading = ref(false)
const messageError = ref('')
const messageTotal = computed(() =>
  (messageRows.value || []).reduce((total, row) => total + row.sendCount, 0)
)
let activeRequest: AbortController | undefined

const disabledDate = (date: Date) =>
  date.getTime() >= dayjs().add(1, 'day').startOf('day').valueOf()
const formatCount = (count: number) => count.toLocaleString('zh-CN')
const percentage = (count: number, total: number) =>
  total === 0 ? 0 : Number(((count / total) * 100).toFixed(1))

const tabVisitRows = computed(() => {
  if (!overview.value) return []
  const { tabVisit } = overview.value.summary
  return [
    { name: '客户分析', count: tabVisit.customerAnalysisCount },
    { name: '用户画像', count: tabVisit.userProfileCount },
    { name: '聊天辅助', count: tabVisit.chatAssistantCount }
  ]
})
const apiUsageRows = computed(() => {
  if (!overview.value) return []
  const { apiUsage } = overview.value.summary
  return [
    { name: '话术生成', count: apiUsage.scriptGenerateCount },
    { name: '话术优化', count: apiUsage.scriptOptimizeCount },
    { name: '匹配八大服务', count: apiUsage.matchEightServicesCount }
  ]
})

async function loadStatistics() {
  if (!dateRange.value || dateRange.value.length !== 2) {
    ElMessage.warning('请选择完整的统计日期')
    return
  }
  activeRequest?.abort()
  const request = new AbortController()
  activeRequest = request
  const params = {
    startDate: dateRange.value[0],
    endDate: dateRange.value[1]
  }
  loading.value = true
  messageLoading.value = true
  errorMessage.value = ''
  messageError.value = ''
  overview.value = null
  messageRows.value = null
  await Promise.all([
    loadOverview(params, request),
    loadMessages(params, request)
  ])
}

async function loadOverview(
  params: { startDate: string; endDate: string },
  request: AbortController
) {
  try {
    const data = await fetchAiAssistantOverview(params, request.signal)
    if (activeRequest === request) overview.value = data
  } catch (error) {
    if (activeRequest === request) {
      errorMessage.value =
        error instanceof Error
          ? error.message
          : '功能使用统计加载失败，请重新查询'
    }
  } finally {
    if (activeRequest === request) loading.value = false
  }
}

async function loadMessages(
  params: { startDate: string; endDate: string },
  request: AbortController
) {
  try {
    const data = await fetchEmployeeMessageCounts(params, request.signal)
    if (activeRequest === request) messageRows.value = data
  } catch (error) {
    if (activeRequest === request) {
      messageError.value =
        error instanceof Error
          ? error.message
          : '员工消息统计加载失败，请重新查询'
    }
  } finally {
    if (activeRequest === request) messageLoading.value = false
  }
}

function reset() {
  dateRange.value = defaultDateRange()
  loadStatistics()
}

onBeforeUnmount(() => {
  activeRequest?.abort()
  activeRequest = undefined
})
loadStatistics()

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      class: "search-form",
      onSubmit: _withModifiers(loadStatistics, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "统计日期" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: dateRange.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
              type: "daterange",
              "value-format": "YYYY-MM-DD",
              "range-separator": "至",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              clearable: false,
              "disabled-date": disabledDate
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              loading: loading.value || messageLoading.value,
              onClick: loadStatistics
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 查询 ")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, { onClick: reset }, {
              default: _withCtx(() => [
                _createTextVNode("重置")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 0,
            title: errorMessage.value,
            type: "error",
            "show-icon": "",
            closable: false
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_unref(DataAnalysis))
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(overview.value ? formatCount(overview.value.summary.tabVisit.totalCount) : '—') + " ", 1),
            _hoisted_9
          ]),
          _hoisted_10
        ])), [
          [_directive_loading, loading.value]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_unref(Connection))
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(_toDisplayString(overview.value ? formatCount(overview.value.summary.apiUsage.totalCount) : '—') + " ", 1),
            _hoisted_15
          ]),
          _hoisted_16
        ])), [
          [_directive_loading, loading.value]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_unref(User))
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createTextVNode(_toDisplayString(overview.value ? formatCount(overview.value.summary.userUsage.userCount) : '—') + " ", 1),
            _hoisted_21
          ]),
          _hoisted_22
        ])), [
          [_directive_loading, loading.value]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("span", _hoisted_24, [
            _createVNode(_unref(ChatDotRound))
          ]),
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createTextVNode(_toDisplayString(messageRows.value ? formatCount(messageTotal.value) : '—') + " ", 1),
            _hoisted_27
          ]),
          _createElementVNode("p", null, _toDisplayString(messageError.value
                ? '加载失败，请重新查询'
                : '统计范围内员工发送的消息总数'), 1)
        ])), [
          [_directive_loading, messageLoading.value]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
        _createElementVNode("section", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            (overview.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "共 " + _toDisplayString(formatCount(overview.value.summary.tabVisit.totalCount)) + " 次", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_table, { data: tabVisitRows.value }, {
            empty: _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                (errorMessage.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      loading: loading.value || messageLoading.value,
                      onClick: loadStatistics
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重新加载")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "功能页面",
                "min-width": "110"
              }),
              _createVNode(_component_el_table_column, {
                label: "访问次数",
                width: "100",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_35, _toDisplayString(formatCount(row.count)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "访问占比",
                "min-width": "180"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_el_progress, {
                      percentage: 
                      percentage(
                        row.count,
                        overview.value.summary.tabVisit.totalCount
                      )
                    ,
                      "show-text": false,
                      "stroke-width": 7,
                      color: "#4d8df7"
                    }, null, 8, ["percentage"]),
                    _createElementVNode("span", null, _toDisplayString(percentage(
                        row.count,
                        overview.value.summary.tabVisit.totalCount
                      )) + "%", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("section", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            (overview.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "共 " + _toDisplayString(formatCount(overview.value.summary.apiUsage.totalCount)) + " 次", 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_table, { data: apiUsageRows.value }, {
            empty: _withCtx(() => [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                (errorMessage.value)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      loading: loading.value || messageLoading.value,
                      onClick: loadStatistics
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重新加载")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "功能名称",
                "min-width": "110"
              }),
              _createVNode(_component_el_table_column, {
                label: "调用次数",
                width: "100",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_43, _toDisplayString(formatCount(row.count)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "调用占比",
                "min-width": "180"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_el_progress, {
                      percentage: 
                      percentage(
                        row.count,
                        overview.value.summary.apiUsage.totalCount
                      )
                    ,
                      "show-text": false,
                      "stroke-width": 7,
                      color: "#8374e8"
                    }, null, 8, ["percentage"]),
                    _createElementVNode("span", null, _toDisplayString(percentage(
                        row.count,
                        overview.value.summary.apiUsage.totalCount
                      )) + "%", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ])), [
        [_directive_loading, loading.value]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          (messageRows.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, "发送员工数 " + _toDisplayString(formatCount(messageRows.value.length)) + " 人 · 共 " + _toDisplayString(formatCount(messageTotal.value)) + " 次", 1))
            : _createCommentVNode("", true)
        ]),
        (messageError.value)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: messageError.value,
              type: "error",
              "show-icon": "",
              closable: false
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table, {
          data: messageRows.value || [],
          "row-key": "empUserId",
          "max-height": 480
        }, {
          empty: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("p", null, _toDisplayString(messageError.value
                    ? '员工消息统计加载失败'
                    : messageLoading.value
                    ? '正在加载统计数据…'
                    : '该时间范围内暂无消息发送记录'), 1),
              (messageError.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    loading: loading.value || messageLoading.value,
                    onClick: loadStatistics
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重新加载")
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "员工姓名",
              "min-width": "140",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "empUserId",
              label: "员工账号",
              "min-width": "180",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "groupName",
              label: "所属组别",
              "min-width": "140",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "发送次数",
              "min-width": "120",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_50, _toDisplayString(formatCount(row.sendCount)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])), [
        [_directive_loading, messageLoading.value]
      ])
    ])
  ]))
}
}

})